import type { ReactNode } from 'react';

import { FIELD_TRIGGER } from './control';
import { Disclosure } from './Disclosure';

interface DisclosureFieldProps {
  label: string;
  /** Что выбрано — видно в строке, не раскрывая. */
  value: ReactNode;
  /** Подсказка под полем: видна и в свёрнутом виде. */
  hint?: string;
  children: ReactNode;
}

/**
 * Поле, варианты которого убраны под стрелку.
 *
 * Для выбора, у которого вариантов много, а нужен он редко: восемнадцать
 * отделов магазина, десяток лекарств аптечки на состав смеси. Кнопками они
 * занимали полкарточки. Свёрнутое поле выглядит как обычное — подпись и строка
 * с выбранным, — и раскрывается по нажатию.
 */
export function DisclosureField({ label, value, hint, children }: DisclosureFieldProps) {
  return (
    <div className="space-y-1.5">
      <p className="text-[13px] font-medium text-muted">{label}</p>
      <Disclosure
        summary={
          <span className="min-w-0 flex-1 truncate text-[15px] text-content">
            <span className="sr-only">{label}: </span>
            {value}
          </span>
        }
        summaryClassName={FIELD_TRIGGER}
      >
        <div className="space-y-2 pt-3">{children}</div>
      </Disclosure>
      {hint && <p className="text-[13px] text-subtle">{hint}</p>}
    </div>
  );
}
